import httpAdmin from '@/httpCommon/axiosClient';

class CommonService {
    getFranchises = async () => {
        const res = await httpAdmin.get('/franchise');
        return res?.data;
    };

    getFranchisesByRole = async () => {
        const res = await httpAdmin.get('/franchise/franchises-by-role');
        return res?.data;
    };

    getStoresByFc = async (id: string | number) => {
        const res = await httpAdmin.get('/store', { params: { franchiseId: id } });
        return res?.data;
    };

    getAllStores = async () => {
        const res = await httpAdmin.get('/store');
        return res?.data;
    };
}
export default new CommonService();
